import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/css";
import { Link } from "react-router-dom";

const Veggie = () => {
  const [veggie, setVeggie] = useState([]);
  useEffect(() => {
    getViggie();
  }, []);
  const getViggie = async () => {
    const checkLocalStorage = localStorage.getItem("veggie");
    if (checkLocalStorage) {
      setVeggie(JSON.parse(checkLocalStorage));
    } else {
      const api = await fetch(
        `https://api.spoonacular.com/recipes/random?apiKey=${process.env.REACT_APP_API_KEY}&number=9&tags=vegetarian`
      );
      const data = await api.json();
      localStorage.setItem("veggie", JSON.stringify(data.recipes));
      setVeggie(data.recipes);
    }
  };

  return (
    <Wrapper>
      <h3>Our Vegetarian picks</h3>
      <Splide
        options={{
          perPage: 3,
          arrows: false,
          pagination: false,
          gap: "1.5rem",
          breakpoints: {
            767: {
              perPage: 2,
              arrows: true,
            },
            500: {
              perPage: 1,
            },
          },
        }}
      >
        {veggie.map((recipe) => {
          return (
            <SplideSlide key={recipe.id}>
              <Card>
                <Link to={`/Recipe/${recipe.id}`}>
                  <p>{recipe.title}</p>
                  <img src={recipe.image} alt={recipe.title} />
                  <Blur />
                </Link>
              </Card>
            </SplideSlide>
          );
        })}
      </Splide>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  h3 {
    padding: 1rem 0rem;
    font-size: 1rem;
  }
`;
const Card = styled.div`
  height: 200px;
  border-radius: 2rem;
  overflow: hidden;
  position: relative;
  img {
    border-radius: 2rem;
    width: 100%;
    position: absolute;
    left: 0;
    height: 100%;
    object-fit: cover;
  }
  p {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0%);
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    text-align: center;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 50px;
  }
  @media screen and (max-width: 1024px) {
    p {
      padding: 20px 10px;
      font-size: 0.7rem;
    }
  }
`;
const Blur = styled.div`
  position: relative;
  z-index: 3;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
`;
export default Veggie;
